var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "#FCDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7188 7.62073C12.7755 7.56599 12.8208 7.50049 12.8519 7.42807C12.8831 7.35564 12.8995 7.27774 12.9002 7.1989C12.901 7.12006 12.886 7.04187 12.8561 6.96889C12.8263 6.89591 12.7823 6.82959 12.7265 6.77382C12.6708 6.71804 12.6046 6.67392 12.5316 6.64403C12.4586 6.61415 12.3805 6.59909 12.3016 6.59973C12.2228 6.60038 12.1449 6.61672 12.0724 6.64781C12 6.67889 11.9344 6.72409 11.8796 6.78077L9.49988 9.15973L7.12092 6.78077C7.06656 6.72244 7.00101 6.67565 6.92818 6.6432C6.85534 6.61075 6.77672 6.5933 6.697 6.59189C6.61727 6.59048 6.53809 6.60515 6.46415 6.63501C6.39022 6.66487 6.32306 6.70932 6.26668 6.7657C6.2103 6.82208 6.16585 6.88924 6.13599 6.96318C6.10612 7.03711 6.09146 7.1163 6.09287 7.19602C6.09427 7.27574 6.11172 7.35437 6.14417 7.4272C6.17663 7.50003 6.22342 7.56558 6.28175 7.61994L8.65913 9.99969L6.28017 12.3786C6.17529 12.4912 6.11819 12.6401 6.1209 12.7939C6.12362 12.9477 6.18593 13.0945 6.29472 13.2033C6.4035 13.3121 6.55027 13.3744 6.70409 13.3771C6.85791 13.3798 7.00678 13.3227 7.11933 13.2178L9.49988 10.8389L11.8788 13.2186C11.9914 13.3235 12.1403 13.3806 12.2941 13.3779C12.4479 13.3752 12.5947 13.3128 12.7035 13.2041C12.8122 13.0953 12.8745 12.9485 12.8773 12.7947C12.88 12.6409 12.8229 12.492 12.718 12.3794L10.3406 9.99969L12.7188 7.62073Z",
    fill: "#D51212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCrossIcon);
export default __webpack_public_path__ + "static/media/InactiveCrossIcon.c218f6288c20820db1423147abed8ce5.svg";
export { ForwardRef as ReactComponent };